export const getUsers = (state) => state.user.usersList;
export const getUserDetails = (state) => state.user.userDetails;
export const getAdvisorDetails = (state) => state.user.advisorDetails;
export const getMessangerDetails = (state) => state.user.messangerDetails;
